import { MEMBERSHIP_TYPE } from '../enums';

export const getMembershipStyle = (membershipType: MEMBERSHIP_TYPE): { icon: string; color: string } => {
   switch (membershipType) {
      case MEMBERSHIP_TYPE.GOLD:
         return { icon: '/assets/icons/memberships/gold-icon.svg', color: '#BFC951' };
      case MEMBERSHIP_TYPE.WHITE:
         return { icon: '/assets/icons/memberships/white-icon.svg', color: '#F5F5F6' };
      case MEMBERSHIP_TYPE.DIAMOND:
         return { icon: '/assets/icons/memberships/diamond-icon.svg', color: '#2498A0' };
      case MEMBERSHIP_TYPE.SILVER:
         return { icon: '/assets/icons/memberships/silver-icon.svg', color: '#868DC0' };
      case MEMBERSHIP_TYPE.GREEN:
      default:
         return { icon: '/assets/icons/memberships/green-icon.svg', color: '#68C072' };
   }
};
